// src/hooks/useBreadcrumb.ts
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useBreadcrumb = (folderNumber?: string, folderName?: string) => {
  const location = useLocation();

  return useMemo(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);

    if (pathSegments[0] === "folders") {
      if (pathSegments.length === 1) {
        // /folders
        return [{ title: "Folders" }];
      } else if (pathSegments.length === 2) {
        // /folders/302118
        return [
          { title: "Folders", href: "/folders" },
          { title: folderName || `Folder ${folderNumber}` },
        ];
      } else if (
        pathSegments[2] === "multireport" &&
        pathSegments[3] === "preview"
      ) {
        // /folders/302118/multireport/preview
        return [
          { title: "Folders", href: "/folders" },
          {
            title: folderName || `Folder ${folderNumber}`,
            href: `/folders/${folderNumber}`,
          },
          { title: "Multireport Preview" },
        ];
      }
    }

    return [{ title: "Home", href: "/" }];
  }, [location.pathname, folderNumber, folderName]);
};
